import React from "react";

// Real brand logos as inline SVGs. Sizes scale with `size` prop.
// All icons are self-contained — no external dependencies.

const WhatsAppIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-label="WhatsApp">
    <defs>
      <linearGradient id="wa-grad" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#25D366" />
        <stop offset="100%" stopColor="#128C7E" />
      </linearGradient>
    </defs>
    <circle cx="16" cy="16" r="16" fill="url(#wa-grad)" />
    <path
      fill="#fff"
      d="M22.6 9.4A8.4 8.4 0 1 0 9 21.9l-1 3.4 3.5-1A8.4 8.4 0 0 0 22.6 9.4Zm-6.6 12.9a7 7 0 0 1-3.6-1l-.3-.2-2.1.6.6-2-.1-.3a7 7 0 1 1 5.5 2.9Zm3.8-5.1c-.2-.1-1.2-.6-1.4-.6-.2-.1-.3-.1-.5.1-.2.2-.5.6-.7.8-.1.1-.2.1-.4 0-.2-.1-.9-.3-1.7-1-.6-.6-1-1.3-1.2-1.5-.1-.2 0-.3.1-.4.1-.1.2-.2.3-.4.1-.1.1-.2.2-.3.1-.2 0-.3 0-.4-.1-.1-.5-1.3-.7-1.7-.2-.4-.4-.4-.5-.4h-.4c-.2 0-.4.1-.6.3-.2.2-.8.8-.8 2s.8 2.3.9 2.5c.1.2 1.6 2.4 3.8 3.4 1.3.5 1.8.6 2.5.5.4-.1 1.2-.5 1.4-1 .2-.5.2-.9.1-1 0-.1-.2-.2-.4-.3Z"
    />
  </svg>
);

const FacebookMessengerIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-label="Messenger">
    <defs>
      <linearGradient id="msg-grad" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#0099FF" />
        <stop offset="100%" stopColor="#A033FF" />
      </linearGradient>
    </defs>
    <path
      fill="url(#msg-grad)"
      d="M16 1.5C7.7 1.5 1.5 7.7 1.5 16c0 4.4 1.9 8.2 5 10.9V30.5l3.6-2c1.8.5 3.8.8 5.9.8 8.3 0 14.5-6.2 14.5-14.5S24.3 1.5 16 1.5Z"
    />
    <path
      fill="#fff"
      d="M7.3 18.8 14 11.7l3.5 3.6 6.6-3.6-6.6 7-3.5-3.5-6.7 3.6Z"
    />
  </svg>
);

const InstagramIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-label="Instagram">
    <defs>
      <radialGradient id="ig-grad" cx="0.3" cy="1" r="1">
        <stop offset="0%" stopColor="#FED576" />
        <stop offset="25%" stopColor="#F47133" />
        <stop offset="55%" stopColor="#BC3081" />
        <stop offset="100%" stopColor="#4C63D2" />
      </radialGradient>
    </defs>
    <rect width="32" height="32" rx="8" fill="url(#ig-grad)" />
    <rect x="7" y="7" width="18" height="18" rx="5" fill="none" stroke="#fff" strokeWidth="2" />
    <circle cx="16" cy="16" r="4.2" fill="none" stroke="#fff" strokeWidth="2" />
    <circle cx="21.4" cy="10.6" r="1.2" fill="#fff" />
  </svg>
);

const LiveChatIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-label="Web Chat">
    <rect width="32" height="32" rx="8" fill="#6366F1" />
    <path
      fill="#fff"
      d="M9 10h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-7l-4 4v-4H9a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2Z"
    />
  </svg>
);

const SmsIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-label="SMS">
    <rect width="32" height="32" rx="8" fill="#10B981" />
    <path
      fill="#fff"
      d="M9 9h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8l-5 5v-5H9a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2Z"
    />
    <text x="16" y="18" textAnchor="middle" fill="#10B981" fontSize="6" fontWeight="bold" fontFamily="Arial">SMS</text>
  </svg>
);

const EmailIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-label="E-Mail">
    <rect width="32" height="32" rx="8" fill="#F59E0B" />
    <path
      fill="#fff"
      d="M8 11a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V11Zm2 0 6 5 6-5H10Zm12 1.2-6 5-6-5V21h12v-8.8Z"
    />
  </svg>
);

const TelegramIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-label="Telegram">
    <circle cx="16" cy="16" r="16" fill="#229ED9" />
    <path
      fill="#fff"
      d="m23.7 9.6-2.6 13c-.2 1-.7 1.2-1.5.8l-4.1-3-2 1.9c-.2.2-.4.4-.8.4l.3-4.3 7.7-7c.4-.3-.1-.4-.6-.2L9.5 16l-4.1-1.3c-.9-.3-.9-.9.2-1.3l16-6.2c.7-.3 1.4.2 1.1 1.5Z"
    />
  </svg>
);

const FallbackIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-label="Message">
    <rect width="32" height="32" rx="8" fill="#94A3B8" />
    <path fill="#fff" d="M9 11a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-7l-4 4v-4h-1a2 2 0 0 1-2-2v-8Z" />
  </svg>
);

export const CHANNEL_LABELS = {
  whats_app: "WhatsApp",
  whatsapp: "WhatsApp",
  facebook_messenger: "Messenger",
  facebook: "Messenger",
  instagram: "Instagram",
  live_chat: "Web Chat",
  sms: "SMS",
  email: "E-Mail",
  mail: "E-Mail",
  telegram: "Telegram",
};

export default function ChannelIcon({ type, size = 24 }) {
  const t = (type || "").toLowerCase();
  if (t === "whats_app" || t === "whatsapp") return <WhatsAppIcon size={size} />;
  if (t === "facebook_messenger" || t === "facebook") return <FacebookMessengerIcon size={size} />;
  if (t === "instagram") return <InstagramIcon size={size} />;
  if (t === "live_chat") return <LiveChatIcon size={size} />;
  if (t === "sms") return <SmsIcon size={size} />;
  if (t === "email" || t === "mail") return <EmailIcon size={size} />;
  if (t === "telegram") return <TelegramIcon size={size} />;
  return <FallbackIcon size={size} />;
}

export function channelLabel(type) {
  return CHANNEL_LABELS[(type || "").toLowerCase()] || type || "?";
}
